import { DataBean } from "../DataBean";


export class RequestAdquisitionItem extends DataBean {

    public async deleteRequestAdquisitionItem(idrequestadquisitionitem: number): Promise<any> {
        return this.getCustomService("SupplierERP", "boolean_deleteRequestAdquisitionItem_Number", [idrequestadquisitionitem]);
    }

    public async getRequestAdquisitionItem(idrequestadquisitionitem: number): Promise<any> {
        return this.getCustomService("SupplierERP", "com.orange.finance.supplier.bean.RequestAdquisitionItem_getRequestAdquisitionItem_Number", [idrequestadquisitionitem]);
    }

    public async getRequestAdquisitionItemCatalogPorPropiedades(properties: any, maxRows: number): Promise<any> {
        return this.getCustomService("SupplierERP", "java.util.List_getRequestAdquisitionItemCatalogPorPropiedades_java.util.Map_Number", [properties, maxRows]);
    }

    public async updateRequestAdquisitionItem(bean: any): Promise<any> {
        return this.getCustomService("SupplierERP", "com.orange.finance.supplier.bean.RequestAdquisitionItem_updateRequestAdquisitionItem_com.orange.finance.supplier.bean.RequestAdquisitionItem", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.orange.finance.supplier.bean.RequestAdquisitionItem"
            }
        ]);
    }

}